import React from 'react';
import { RetrieveRequest } from '../../../utilities/services/RequestService';
import { getOptionsDeactive } from '../../../utilities/actions/Helpers';
import { Alert } from '../../index';
import { Select, Form } from 'antd';
import { api } from '../../../config/Services';

const { Option } = Select;

class CountrySelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            loading: false
        }
    }

    addCountryInactive = (countryname, countrycode) => {
        if (countrycode) {
            let countryinactive = { countryname, countrycode };
            this.retrieveData({}, countryinactive);
        }
    }

    retrieveData(criteria = {}, countryinactive = {}, actionspage = 'create') {
        let paging = { limit: -1, page: 1 }
        let sort = { countryname: 'asc' };
        let url = api.url.masterdata.country.retrieve;
        criteria.active = true;
        let column = [];
        this.setState({ loading: true });
        RetrieveRequest(url, criteria, sort, paging, column).then((response) => {
            const { status = {} } = response || {};
            if (status.responsecode === '0000') {
                var options = response.result.map(({ countryname, countrycode }) => {
                    return {
                        label: countryname,
                        value: countrycode
                    };
                });

                //if options deactive
                const { countrycode, countryname } = countryinactive;
                if (countrycode) {
                    options = getOptionsDeactive(actionspage, options, countrycode, countryname);
                }

                this.setState(prevState => ({
                    options,
                    loading: false
                }));
            } else {
                Alert.error(response.status.responsemessage);
            }
        });
    }

    validationRules = () => {
        let validation = [];
        if (this.props.validationrules) {
            (this.props.validationrules).forEach((item, index) => {
                if (typeof (item) === "string") {
                    let valType = item.split(".");
                    switch (valType[0]) {
                        case "required":
                            validation.push({ required: true, message: `${this.props.labeltext} is Required` })
                            break;
                        default:
                    }
                }
                else if (typeof (item) === "function") {
                    validation.push({
                        validator: item
                    })
                }
            })
        }

        return validation;
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { options, loading } = this.state;
        return (
            <Form.Item label={this.props.labeltext} className={this.props.className} extra={this.props.extra}>
                {getFieldDecorator(this.props.datafield, {
                    rules: this.validationRules(),
                    initialValue: this.props.defaultValue
                })(
                    <Select loading={loading} showSearch optionFilterProp="children" placeholder={"Choose " + this.props.labeltext} onChange={this.props.onChange} allowClear={true} disabled={this.props.disabled}>
                        {options.map((obj, key) => (
                            <Option key={key} value={obj.value}>{obj.label}</Option>
                        ))}
                    </Select>,
                )}
            </Form.Item>
        )
    }

}

export default CountrySelect;